export default "__VITE_ASSET__6Dkiv$XL__"